import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { setNotificationQuestion, setSelectedQuestion } from '../store/actions';
import { debounce } from '../../../helpers/debounce';

const useFilterChange = ({ action, delay }) => {
  const dispatch = useDispatch();

  const change = useCallback(
    (values) => {
      dispatch(action(values));
      dispatch(setSelectedQuestion(null));
      dispatch(setNotificationQuestion(undefined));
    },
    [action, dispatch]
  );

  return useMemo(
    () => (delay ? debounce(change, delay) : change),
    [change, delay]
  );
};

export default useFilterChange;
